import React, { FC } from "react";
import { HeadingProps, Heading as ThemeUIHeading, useThemeUI } from "theme-ui";
import { mergeHeadingStyles } from "../variant-helper";

export const Heading: FC<HeadingProps> = ({
  children,
  ...props
}: HeadingProps) => {
  const headingAs = props.as ?? "h2";
  const themeContext = useThemeUI();
  const sxProps = mergeHeadingStyles(
    themeContext,
    `${headingAs}`,
    props.variant
  );

  return (
    <ThemeUIHeading
      css="word-break: break-word;"
      {...props}
      as={headingAs}
      sx={sxProps}
    >
      {children}
    </ThemeUIHeading>
  );
};

type TagLineProps = {} & HeadingProps;
export const TagLine: FC<TagLineProps> = (props: TagLineProps) => {
  const { children } = props;
  return (
    <Heading as="h6" variant="tagline" {...props}>
      {children}
    </Heading>
  );
};
